import DOMPurify from 'dompurify';
import React, { useMemo } from 'react';

interface FragmentProps {
    text: string;
    replacements?: Record<string, any>;
}

const Fragment: React.FC<FragmentProps> = ({ text, replacements = {} }) => {
    const replacePlaceholders = (text: string, replacements: Record<string, any>) => {
        return text.replace(/\{\{(.*?)\}\}/g, (_, key) => {
            const value = replacements[key.trim()];
            return value !== undefined ? String(value) : '';
        });
    };

    const processedText = useMemo(() => {
        const replacedText = replacePlaceholders(text, replacements);
        return DOMPurify.sanitize(replacedText);
    }, [text, replacements]);

    return <div dangerouslySetInnerHTML={{ __html: processedText }} />;
};

export default Fragment;